import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwSpinnerModule } from '@aw-hospital/aw-components-lib/aw-spinner';
import { AwComponent } from '@aw-hospital/aw-components-lib/aw-parent';
import { attrToBoolean } from '@aw-hospital/aw-components-lib/src/utils';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@aw-hospital/aw-components-lib/aw-spinner';

function AwButtonComponent_button_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c0 = function (a0, a1) { return [a0, a1]; };
function AwButtonComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("click", function AwButtonComponent_button_0_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.click($event); })("focus", function AwButtonComponent_button_0_Template_button_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.focus($event); })("blur", function AwButtonComponent_button_0_Template_button_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.blur($event); })("keyup", function AwButtonComponent_button_0_Template_button_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.keyup.emit($event); })("keydown", function AwButtonComponent_button_0_Template_button_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.keydown.emit($event); });
    ɵngcc0.ɵɵtemplate(1, AwButtonComponent_button_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("type", ctx_r0.type)("ngClass", ɵngcc0.ɵɵpureFunction2(14, _c0, ctx_r0.styleClasses ? ctx_r0.styleClasses : "", ctx_r0.disabled ? "disabled" : ""));
    ɵngcc0.ɵɵattribute("id", ctx_r0.elementId)("automation", ctx_r0.automationValue || "buttonComponent")("aria-expanded", ctx_r0.awAriaExpanded)("aria-haspopup", ctx_r0.awAriaHaspopup)("aria-hidden", ctx_r0.awAriaHidden)("aria-label", ctx_r0.awAriaLabel)("aria-pressed", ctx_r0.awAriaPressed)("aria-describedby", ctx_r0.awAriaDescribedBy)("tabindex", ctx_r0.tabindex)("aria-controls", ctx_r0.awAriaControls)("form", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function AwButtonComponent_button_1_aw_spinner_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "aw-spinner", 13);
} }
function AwButtonComponent_button_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c1 = function (a0) { return { width: a0 }; };
function AwButtonComponent_button_1_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵelement(1, "span", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(1, _c1, ctx_r13.progress + "%"));
} }
function AwButtonComponent_button_1_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.getStatusMessage(ctx_r14.state, ctx_r14.progress), " ");
} }
const _c2 = function (a0, a1, a2, a3, a4) { return [a0, a1, a2, a3, a4]; };
function AwButtonComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function AwButtonComponent_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.click($event); })("keyup", function AwButtonComponent_button_1_Template_button_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.keyup.emit($event); })("keydown", function AwButtonComponent_button_1_Template_button_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.keydown.emit($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "span", 7);
    ɵngcc0.ɵɵtemplate(3, AwButtonComponent_button_1_aw_spinner_3_Template, 1, 0, "aw-spinner", 8);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtemplate(5, AwButtonComponent_button_1_ng_container_5_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "span", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, AwButtonComponent_button_1_span_7_Template, 2, 3, "span", 10);
    ɵngcc0.ɵɵelementStart(8, "div", 11);
    ɵngcc0.ɵɵtemplate(9, AwButtonComponent_button_1_span_9_Template, 2, 1, "span", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("type", ctx_r1.type)("ngClass", ɵngcc0.ɵɵpureFunction5(19, _c2, ctx_r1.styleClasses ? ctx_r1.styleClasses : "", ctx_r1.isProgress && !ctx_r1.isError && !ctx_r1.isSuccess ? "state-loading" : "", ctx_r1.isError ? "state-error" : "", ctx_r1.isSuccess ? "state-success" : "", ctx_r1.disabled ? "disabled" : ""));
    ɵngcc0.ɵɵattribute("id", ctx_r1.elementId)("automation", ctx_r1.automationValue ? ctx_r1.automationValue + "ProgressButton" : "progressButton")("aria-expanded", ctx_r1.awAriaExpanded)("aria-haspopup", ctx_r1.awAriaHaspopup)("aria-hidden", ctx_r1.awAriaHidden)("aria-label", ctx_r1.awAriaLabel)("aria-pressed", ctx_r1.awAriaPressed)("aria-describedby", ctx_r1.awAriaDescribedBy)("tabindex", ctx_r1.tabindex)("aria-controls", ctx_r1.awAriaControls)("form", ctx_r1.form);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.hasSpinner);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("opacity", ctx_r1.hasSpinner ? 0 : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isProgress);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isProgress);
} }
function AwButtonComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c3 = ["*"];
const DEFAULT_STATUS_MESSAGES = {
    error: 'Error on loading',
    success: 'Successfully loaded',
    loading: 'Loading'
};
class AwButtonComponent extends AwComponent {
    constructor() {
        super(...arguments);
        this.awAriaExpanded = null;
        this.awAriaHaspopup = null;
        this.awAriaHidden = null;
        this.awAriaLabel = null;
        this.awAriaPressed = null;
        this.awAriaDescribedBy = null;
        this.statusMessages = {
            error: DEFAULT_STATUS_MESSAGES.error,
            progress: ((v) => {
                if (v === true || v === 0) {
                    return DEFAULT_STATUS_MESSAGES.loading;
                }
                if (typeof v === 'number') {
                    return `${v}%`;
                }
                return v || '';
            }),
            success: DEFAULT_STATUS_MESSAGES.success
        };
        this.type = 'button';
        this.onClick = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.keyup = new EventEmitter();
        this.keydown = new EventEmitter();
        this.progressChange = new EventEmitter();
        this.stateChange = new EventEmitter();
        this.testName = 'aw-button';
        this.loading = false;
        this._disabled = false;
        this._progressive = false;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = attrToBoolean(value);
    }
    get progress() {
        return this._progress;
    }
    set progress(progress) {
        this._progress = progress;
        if (typeof progress === 'boolean') {
            this.loading = progress;
        }
    }
    get progressive() {
        return this._progressive;
    }
    set progressive(value) {
        this._progressive = attrToBoolean(value);
    }
    get isError() {
        return this.state === 'error';
    }
    get isProgress() {
        return typeof this.progress === 'number' || !!this.state || this.loading;
    }
    get hasSpinner() {
        return this.loading === true;
    }
    get isSuccess() {
        return this.state === 'success';
    }
    getStatusMessage(status, progress) {
        if (status === 'success') {
            return this.statusMessages.success;
        }
        if (status === 'error') {
            return this.statusMessages.error;
        }
        return this.statusMessages.progress(progress);
    }
    click(event) {
        if (this.disabled || this.progress || this.state) {
            return;
        }
        this.onClick.emit(event);
    }
    blur(event) {
        this.onBlur.emit(event);
    }
    focus(event) {
        this.onFocus.emit(event);
    }
}
AwButtonComponent.ɵfac = function AwButtonComponent_Factory(t) { return ɵAwButtonComponent_BaseFactory(t || AwButtonComponent); };
AwButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwButtonComponent, selectors: [["aw-button"]], inputs: { awAriaExpanded: ["aw-aria-expanded", "awAriaExpanded"], awAriaHaspopup: ["aw-aria-haspopup", "awAriaHaspopup"], awAriaHidden: ["aw-aria-hidden", "awAriaHidden"], awAriaLabel: ["aw-aria-label", "awAriaLabel"], awAriaPressed: ["aw-aria-pressed", "awAriaPressed"], awAriaDescribedBy: ["aw-aria-describedby", "awAriaDescribedBy"], statusMessages: "statusMessages", type: "type", disabled: "disabled", progress: "progress", progressive: "progressive", tabindex: ["aw-tabindex", "tabindex"], awAriaControls: ["aw-aria-controls", "awAriaControls"], elementId: "elementId", state: "state", styleClasses: "styleClasses", form: "form" }, outputs: { onClick: "onClick", onBlur: "onBlur", onFocus: "onFocus", keyup: "keyup", keydown: "keydown", progressChange: "progressChange", stateChange: "stateChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c3, decls: 4, vars: 2, consts: [[3, "type", "ngClass", "click", "focus", "blur", "keyup", "keydown", 4, "ngIf"], ["class", "progress-button progress-button-dir-horizontal progress-button-style-fill", 3, "type", "ngClass", "click", "keyup", "keydown", 4, "ngIf"], ["contentTemplate", ""], [3, "type", "ngClass", "click", "focus", "blur", "keyup", "keydown"], [4, "ngTemplateOutlet"], [1, "progress-button", "progress-button-dir-horizontal", "progress-button-style-fill", 3, "type", "ngClass", "click", "keyup", "keydown"], [1, "progress-hold-content"], [1, "progress-button-content"], ["aria-hidden", "true", "spinnerColor", "spinner-white-only", "class", "flex justify-center", 4, "ngIf"], ["aria-hidden", "true", "automation", "buttonContent", 1, "content"], ["aria-hidden", "true", "automation", "progressButtonBar", "class", "progress-btn-bar", 4, "ngIf"], ["aria-live", "polite", 1, "visuallyhidden"], [4, "ngIf"], ["aria-hidden", "true", "spinnerColor", "spinner-white-only", 1, "flex", "justify-center"], ["aria-hidden", "true", "automation", "progressButtonBar", 1, "progress-btn-bar"], ["automation", "progressInner", 1, "progress-inner", 3, "ngStyle"]], template: function AwButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, AwButtonComponent_button_0_Template, 2, 17, "button", 0);
        ɵngcc0.ɵɵtemplate(1, AwButtonComponent_button_1_Template, 10, 25, "button", 1);
        ɵngcc0.ɵɵtemplate(2, AwButtonComponent_ng_template_2_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.progressive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.progressive);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet, ɵngcc2.AwSpinnerComponent, ɵngcc1.NgStyle], encapsulation: 2, changeDetection: 0 });
AwButtonComponent.selectorDowngrade = 'aw-button';
AwButtonComponent.propDecorators = {
    awAriaExpanded: [{ type: Input, args: ['aw-aria-expanded',] }],
    awAriaHaspopup: [{ type: Input, args: ['aw-aria-haspopup',] }],
    awAriaHidden: [{ type: Input, args: ['aw-aria-hidden',] }],
    awAriaLabel: [{ type: Input, args: ['aw-aria-label',] }],
    awAriaPressed: [{ type: Input, args: ['aw-aria-pressed',] }],
    awAriaDescribedBy: [{ type: Input, args: ['aw-aria-describedby',] }],
    tabindex: [{ type: Input, args: ['aw-tabindex',] }],
    awAriaControls: [{ type: Input, args: ['aw-aria-controls',] }],
    disabled: [{ type: Input, args: ['disabled',] }],
    elementId: [{ type: Input }],
    progress: [{ type: Input }],
    progressive: [{ type: Input, args: ['progressive',] }],
    state: [{ type: Input }],
    statusMessages: [{ type: Input }],
    styleClasses: [{ type: Input }],
    form: [{ type: Input }],
    type: [{ type: Input }],
    onClick: [{ type: Output }],
    onBlur: [{ type: Output }],
    onFocus: [{ type: Output }],
    keyup: [{ type: Output }],
    keydown: [{ type: Output }],
    progressChange: [{ type: Output }],
    stateChange: [{ type: Output }]
};
const ɵAwButtonComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwButtonComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwButtonComponent, [{
        type: Component,
        args: [{
                selector: 'aw-button',
                template: "<button\n    [attr.id]=\"elementId\"\n    [attr.automation]=\"automationValue || 'buttonComponent'\"\n    [attr.aria-expanded]=\"awAriaExpanded\"\n    [attr.aria-haspopup]=\"awAriaHaspopup\"\n    [attr.aria-hidden]=\"awAriaHidden\"\n    [attr.aria-label]=\"awAriaLabel\"\n    [attr.aria-pressed]=\"awAriaPressed\"\n    [attr.aria-describedby]=\"awAriaDescribedBy\"\n    [attr.tabindex]=\"tabindex\"\n    [attr.aria-controls]=\"awAriaControls\"\n    [attr.form]=\"form\"\n    [type]=\"type\"\n    [ngClass]=\"[\n        styleClasses ? styleClasses : '',\n        disabled ? 'disabled' : ''\n    ]\"\n    (click)=\"click($event)\"\n    (focus)=\"focus($event)\"\n    (blur)=\"blur($event)\"\n    (keyup)=\"keyup.emit($event)\"\n    (keydown)=\"keydown.emit($event)\"\n    *ngIf=\"!progressive\">\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</button>\n<button\n    class=\"progress-button progress-button-dir-horizontal progress-button-style-fill\"\n    [attr.id]=\"elementId\"\n    [attr.automation]=\"automationValue ? (automationValue + 'ProgressButton') : 'progressButton'\"\n    [attr.aria-expanded]=\"awAriaExpanded\"\n    [attr.aria-haspopup]=\"awAriaHaspopup\"\n    [attr.aria-hidden]=\"awAriaHidden\"\n    [attr.aria-label]=\"awAriaLabel\"\n    [attr.aria-pressed]=\"awAriaPressed\"\n    [attr.aria-describedby]=\"awAriaDescribedBy\"\n    [attr.tabindex]=\"tabindex\"\n    [attr.aria-controls]=\"awAriaControls\"\n    [attr.form]=\"form\"\n    [type]=\"type\"\n    [ngClass]=\"[\n        styleClasses ? styleClasses : '',\n        isProgress && !isError && !isSuccess ? 'state-loading' : '',\n        isError ? 'state-error' : '',\n        isSuccess ? 'state-success' : '',\n        disabled ? 'disabled' : ''\n    ]\"\n    (click)=\"click($event)\"\n    (keyup)=\"keyup.emit($event)\"\n    (keydown)=\"keydown.emit($event)\"\n    *ngIf=\"progressive\">\n    <div class=\"progress-hold-content\">\n        <span class=\"progress-button-content\">\n            <aw-spinner\n                *ngIf=\"hasSpinner\"\n                aria-hidden=\"true\"\n                spinnerColor=\"spinner-white-only\"\n                class=\"flex justify-center\">\n            </aw-spinner>\n            <span [style.opacity]=\"hasSpinner ? 0 : null\">\n                <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n            </span>\n            <span aria-hidden=\"true\"  class=\"content\" automation=\"buttonContent\"></span>\n        </span>\n        <span\n            *ngIf=\"isProgress\"\n            aria-hidden=\"true\"\n            automation=\"progressButtonBar\"\n            class=\"progress-btn-bar\">\n            <span class=\"progress-inner\"\n                automation=\"progressInner\"\n                [ngStyle]=\"{width: progress + '%'}\">\n            </span>\n        </span>\n        <div class=\"visuallyhidden\" aria-live=\"polite\">\n            <span *ngIf=\"isProgress\" >\n                {{ getStatusMessage(state, progress) }}\n            </span>\n        </div>\n    </div>\n</button>\n<ng-template #contentTemplate>\n    <ng-content></ng-content>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, { awAriaExpanded: [{
            type: Input,
            args: ['aw-aria-expanded']
        }], awAriaHaspopup: [{
            type: Input,
            args: ['aw-aria-haspopup']
        }], awAriaHidden: [{
            type: Input,
            args: ['aw-aria-hidden']
        }], awAriaLabel: [{
            type: Input,
            args: ['aw-aria-label']
        }], awAriaPressed: [{
            type: Input,
            args: ['aw-aria-pressed']
        }], awAriaDescribedBy: [{
            type: Input,
            args: ['aw-aria-describedby']
        }], statusMessages: [{
            type: Input
        }], type: [{
            type: Input
        }], onClick: [{
            type: Output
        }], onBlur: [{
            type: Output
        }], onFocus: [{
            type: Output
        }], keyup: [{
            type: Output
        }], keydown: [{
            type: Output
        }], progressChange: [{
            type: Output
        }], stateChange: [{
            type: Output
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }], progress: [{
            type: Input
        }], progressive: [{
            type: Input,
            args: ['progressive']
        }], tabindex: [{
            type: Input,
            args: ['aw-tabindex']
        }], awAriaControls: [{
            type: Input,
            args: ['aw-aria-controls']
        }], elementId: [{
            type: Input
        }], state: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();
if (false) {
    AwButtonComponent.selectorDowngrade;
    AwButtonComponent.prototype.awAriaExpanded;
    AwButtonComponent.prototype.awAriaHaspopup;
    AwButtonComponent.prototype.awAriaHidden;
    AwButtonComponent.prototype.awAriaLabel;
    AwButtonComponent.prototype.awAriaPressed;
    AwButtonComponent.prototype.awAriaDescribedBy;
    AwButtonComponent.prototype.tabindex;
    AwButtonComponent.prototype.awAriaControls;
    AwButtonComponent.prototype.elementId;
    AwButtonComponent.prototype.state;
    AwButtonComponent.prototype.statusMessages;
    AwButtonComponent.prototype.styleClasses;
    AwButtonComponent.prototype.form;
    AwButtonComponent.prototype.type;
    AwButtonComponent.prototype.onClick;
    AwButtonComponent.prototype.onBlur;
    AwButtonComponent.prototype.onFocus;
    AwButtonComponent.prototype.keyup;
    AwButtonComponent.prototype.keydown;
    AwButtonComponent.prototype.progressChange;
    AwButtonComponent.prototype.stateChange;
    AwButtonComponent.prototype.testName;
    AwButtonComponent.prototype.loading;
    AwButtonComponent.prototype.status;
    AwButtonComponent.prototype._disabled;
    AwButtonComponent.prototype._progressive;
    AwButtonComponent.prototype._progress;
}

class AwButtonModule {
}
AwButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwButtonModule });
AwButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwButtonModule_Factory(t) { return new (t || AwButtonModule)(); }, imports: [[
            CommonModule,
            AwSpinnerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwButtonModule, { declarations: function () { return [AwButtonComponent]; }, imports: function () { return [CommonModule,
        AwSpinnerModule]; }, exports: function () { return [AwButtonComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AwSpinnerModule
                ],
                declarations: [
                    AwButtonComponent
                ],
                exports: [
                    AwButtonComponent
                ]
            }]
    }], null, null); })();

export { AwButtonComponent, AwButtonModule, DEFAULT_STATUS_MESSAGES };

//# sourceMappingURL=aw-hospital-aw-components-lib-aw-button.js.map